import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import RatingIcon from '../../../rating-icon';
import { SmileyType } from '../../../rating-icon/types';
import { Rating } from '../../../../../components/rating/src/types';
import * as S from './styles';

type OwnProps = {
  featured: boolean;
  rating: Rating;
  scoreVisibility?: 'row' | 'compact';
  showPriceListRatingExperiment: boolean;
  size?: 'small' | 'normal';
};

const RatingSmiley = ({
  featured,
  rating,
  scoreVisibility,
  showPriceListRatingExperiment,
  size = 'normal',
}: OwnProps) => {
  const { t } = useContext(AppContext);
  let type;
  const iconSize = size === 'small' ? 17 : 21;

  if (rating.real < 2) type = SmileyType.DISSATISFIED;
  if (rating.real >= 2 && rating.real < 3) type = SmileyType.NEUTRAL;
  if (rating.real >= 3 && rating.real < 4) type = SmileyType.SMILING;
  if (rating.real >= 4) type = SmileyType.LAUGHING;

  return type ? (
    <S.RatingSmiley>
      <S.RatingExperiment
        aria-label={t('reviews', 'rating.rate-n-text-version', {
          n: rating.roundedString,
        })}
        data-rating={rating.roundedString}
        scoreVisibility={scoreVisibility}
        showPriceListRatingExperiment={showPriceListRatingExperiment}
        size={size}
      >
        <RatingIcon type={type} disabled={!featured} size={iconSize} />
      </S.RatingExperiment>
    </S.RatingSmiley>
  ) : null;
};

export default RatingSmiley;
